export default [
  {
    title: 'Tableau de bord',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Colis',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Liste des colis',
        route: 'orders-index',
      },
      {
        title: 'Réception Centre',
        route: 'order-status',
        icon: 'TargetIcon',
      },
      {
        title: 'Échange',
        route: 'echange-order',
        icon: 'TargetIcon',
      },
    ],
  },
  {
    title: 'Bon de livraison',
    icon: 'FileIcon',
    route: 'delivery-note-list',
  },
  {
    title: 'Pickup',
    icon: 'ShoppingCartIcon',
    route: 'pickup-list',
  },
  {
    title: 'Inventaire',
    icon: 'ArchiveIcon',
    children: [
      {
        title: 'Scanner inventaire',
        route: 'inventory-dashboard',
      },
      {
        title: 'Historique inventaires',
        route: 'inventory-history',
      },
    ],
  },
  {
    title: 'Run sheet',
    icon: 'FilePlusIcon',
    children: [
      {
        title: 'Run sheet list',
        route: 'roadmap-list',
      },
      {
        title: 'Add run sheet',
        route: { name: 'roadmap-add' },
      },
    ],
  },
  {
    title: 'Traitement anomalie',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste traitement anomalie',
        route: 'bon-retour-list',
      },
      {
        title: 'Ajouter un bon de retour',
        route: { name: 'bon-retour-add' },
      },
    ],
  },
  {
    title: 'Retour inter-agence',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste des retours inter-agence',
        route: 'bon-retour-list-inter-agence',
      },
      {
        title: 'Ajouter un retour inter-agence',
        route: { name: 'bon-retour-inter-agence-add' },
      },
    ],
  },
  {
    title: 'Bon de transfert',
    icon: 'ExternalLinkIcon',
    children: [
      {
        title: 'Réception Centre',
        route: 'reception-transfert',
        icon: 'TargetIcon',
      },
      {
        title: 'Liste des bons de transfert',
        route: 'bon-transfert-list',
      },
      {
        title: 'Ajouter un bon de transfert',
        route: { name: 'bon-transfert-add' },
      },
    ],
  },
  {
    title: 'Support',
    icon: 'mdi-lifebuoy',
    children: [
      {
        title: 'Tickets de support',
        icon: 'HelpCircleIcon',
        route: 'SupportTicketList',
      },
      {
        title: 'Réclamations Livreur',
        icon: 'TruckIcon',
        route: 'support-driver-ticket-list',
      },
      {
        title: 'Demandes de nouvelle livraison',
        icon: 'TruckIcon',
        route: 'RedeliveryRequestList',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Demandes de modification de prix',
        icon: 'DollarSignIcon',
        route: 'PriceChangeRequestList',
        meta: { requiresAdmin: true },
      },
    ],
  },
]
